export const pollQuestions = [
  {
    question: "Of the below 5 Soft Skills on an Employee Twin, the one I rate highest is:",
    options: [
      { label: "Currency Converter", value: "currency_converter" },
      { label: "Fun Facts", value: "fun_facts" },
      // { label: "Coin Toss", value: "coin_toss" },
      { label: "Dictionary", value: "dictionary" },
      { label: "World Clock", value: "world_clock" },
    ],
  },
  {
    question: "I’d love to see the below Skill added to the ET’s CV:",
    options: [
      { label: "Instant Natural Language Query results from 2 or more SAP Tables", value: "sap_tables" },
      { label: "Current status and YOY trend of KPIs listed for me/my function", value: "kpi_trend" },
      { label: "Timesheet Review of my T&M Vendors", value: "timesheet_review" },
      { label: "Questions you ask me to learn more and help better", value: "timesheet_review" },
    ],
  },
  {
    question: "What's your favorite BOT character from movies?",
    options: [
      { label: "TARS - Interstellar", value: "tars_interstellar" },
      { label: "CASE - Interstellar", value: "case_interstellar" },
      { label: "Android - Alien", value: "android_alien" },
      { label: "R2-D2 and C-3PO - Star Wars", value: "r2d2_c3po_starwars" },
    ],
  },
];
